import React from 'react';
import {
  createSession,
  createMessage,
  createConversation,
  getModeration,
} from '../services/backendService';
import { SupportedLanguage } from '../lib/i18n';

const ErrorTest = () => {
  // Test error handling for conversation creation
  const testUnauthorized = async () => {
    try {
      const result = await createConversation({
        language: 'en' as SupportedLanguage,
      });
      console.log('Conversation creation result:', result);
    } catch (error) {
      console.log('Conversation creation error:', error);
    }
  };

  // Test a 400 bad request
  const testBadRequest = async () => {
    try {
      const result = await createMessage({
        conversationId: 'invalid-conversation-id',
        role: 'invalid-role',
        content: '',
        topic: '', // missing topic
        language: 'en' as SupportedLanguage,
      });
      console.log('400 test result:', result);
    } catch (error) {
      console.log('400 test error:', error);
    }
  };

  // Test moderation service
  const testNetworkTimeout = async () => {
    try {
      const result = await getModeration({
        message: 'test message',
        language: 'en' as SupportedLanguage,
      });
      console.log('Moderation test result:', result);
    } catch (error) {
      console.log('Moderation test error:', error);
    }
  };

  // Test a runtime error
  const testRuntimeError = () => {
    // This will trigger a runtime error that should be caught by Sentry
    throw new Error('Intentional test error');
  };

  // Test rate limiting with multiple rapid requests
  const testRateLimit = async () => {
    const promises = Array.from({ length: 20 }).map(() =>
      createSession({
        gender: 'other',
        consent: true,
        language: 'en' as SupportedLanguage,
      })
    );
    const results = await Promise.all(promises);
    console.log('Rate limit test results:', results);
  };

  return (
    <div className="p-4">
      <h1 className="mb-4 text-xl">Error Testing Dashboard</h1>

      <div className="space-y-4">
        <button className="block w-full rounded border p-2" onClick={testUnauthorized}>
          Test 401 Unauthorized
        </button>

        <button className="block w-full rounded border p-2" onClick={testBadRequest}>
          Test 400 Bad Request
        </button>

        <button className="block w-full rounded border p-2" onClick={testNetworkTimeout}>
          Test Network Timeout
        </button>

        <button className="block w-full rounded border p-2" onClick={testRuntimeError}>
          Test Runtime Error
        </button>

        <button className="block w-full rounded border p-2" onClick={testRateLimit}>
          Test Rate Limiting
        </button>
      </div>

      <div className="mt-4 rounded border p-4">
        <h3 className="mb-2 font-medium">Instructions:</h3>
        <ul className="list-disc pl-5">
          <li>Open your browsers console to see detailed error responses</li>
          <li>Check Sentry dashboard for error reports</li>
          <li>Verify error toasts appear correctly</li>
          <li>Test with network throttling in DevTools for more realistic scenarios</li>
        </ul>
      </div>
    </div>
  );
};

export default ErrorTest;
